import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { KPICard } from '../../components/ui/KPICard';
import { Card } from '../../components/ui/Card';
import { DataTable } from '../../components/ui/DataTable';
import { Tabs } from '../../components/ui/Tabs';
import { Button } from '../../components/ui/Button';
import { StatusPill } from '../../components/ui/StatusPill';
import { Drawer } from '../../components/ui/Drawer';
import { TrendingUpIcon, AlertTriangleIcon, CheckCircleIcon, DownloadIcon, MessageSquareIcon } from 'lucide-react';
const forecastData = [{
  id: '1',
  code: 'SEA-PRW-001',
  desc: 'Tiger Prawns',
  apr: 800,
  may: 850,
  jun: 900,
  total: 2550,
  lastQ: 2420,
  var: '+5.2%',
  status: 'Confirmed'
}, {
  id: '2',
  code: 'SEA-SAL-002',
  desc: 'Salmon Fillet',
  apr: 600,
  may: 650,
  jun: 700,
  total: 1950,
  lastQ: 1800,
  var: '+8.1%',
  status: 'Pending'
}, {
  id: '3',
  code: 'SEA-SQD-003',
  desc: 'Fresh Squid',
  apr: 1200,
  may: 1100,
  jun: 1300,
  total: 3600,
  lastQ: 3680,
  var: '-2.3%',
  status: 'Confirmed'
}, {
  id: '4',
  code: 'SEA-CRB-004',
  desc: 'Sri Lankan Crab',
  apr: 400,
  may: 450,
  jun: 500,
  total: 1350,
  lastQ: 1200,
  var: '+12.5%',
  status: 'Constrained'
}, {
  id: '5',
  code: 'SEA-MSL-005',
  desc: 'Green Lip Mussels',
  apr: 1000,
  may: 950,
  jun: 1050,
  total: 3000,
  lastQ: 2890,
  var: '+3.8%',
  status: 'Confirmed'
}, {
  id: '6',
  code: 'SEA-FLT-006',
  desc: 'Barramundi Fillet',
  apr: 1600,
  may: 1500,
  jun: 1700,
  total: 4800,
  lastQ: 4500,
  var: '+6.7%',
  status: 'Pending'
}];
export const ForecastPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('current');
  const [selectedItem, setSelectedItem] = useState<any>(null);
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-1109">
      <PageHeader title="Forecast Collaboration" breadcrumbs={[{
      label: 'Home',
      href: '/supplier/dashboard'
    }, {
      label: 'Forecast'
    }]} primaryAction={<Button leftIcon={<DownloadIcon className="w-4 h-4" data-id="element-1112" />} data-id="element-1111">
            Download Data
          </Button>} data-id="element-1110" />
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-1113">
        <KPICard title="Q2 2026 Status" value="Pending" icon={<TrendingUpIcon className="w-5 h-5" data-id="element-1115" />} data-id="element-1114" />
        <KPICard title="Total Forecast Value" value="$1.2M" icon={<TrendingUpIcon className="w-5 h-5" data-id="element-1117" />} trend="up" trendValue="+5.4%" data-id="element-1116" />
        <KPICard title="Constrained Items" value="1" icon={<AlertTriangleIcon className="w-5 h-5 text-status-warning" data-id="element-1119" />} data-id="element-1118" />
        <KPICard title="Confirmed Items" value="3" icon={<CheckCircleIcon className="w-5 h-5 text-status-success" data-id="element-1121" />} data-id="element-1120" />
      </div>
      <Card noPadding data-id="element-1122">
        <div className="px-6 pt-4 border-b border-border-light" data-id="element-1123">
          <Tabs tabs={[{
          id: 'current',
          label: 'Current Forecast'
        }, {
          id: 'history',
          label: 'History'
        }, {
          id: 'capacity',
          label: 'Capacity'
        }]} activeTab={activeTab} onChange={setActiveTab} data-id="element-1124" />
        </div>
        <div className="p-6" data-id="element-1125">
          <div className="flex justify-between items-center mb-4" data-id="element-1126">
            <h3 className="text-lg font-semibold text-text-primary" data-id="element-1127">
              Demand Forecast Grid
            </h3>
            <div className="flex gap-2" data-id="element-1128">
              <Button variant="secondary" data-id="element-1129">Submit Counter-Proposal</Button>
              <Button variant="primary" data-id="element-1130">Confirm All</Button>
            </div>
          </div>
          <DataTable data={forecastData} columns={[{
          header: 'Material Code',
          accessorKey: 'code'
        }, {
          header: 'Description',
          accessorKey: 'desc'
        }, {
          header: 'Apr 2026',
          accessorKey: 'apr',
          align: 'right'
        }, {
          header: 'May 2026',
          accessorKey: 'may',
          align: 'right'
        }, {
          header: 'Jun 2026',
          accessorKey: 'jun',
          align: 'right'
        }, {
          header: 'Q2 Total',
          accessorKey: 'total',
          align: 'right'
        }, {
          header: 'Variance',
          accessorKey: 'var',
          align: 'right'
        }, {
          header: 'Status',
          cell: row => <StatusPill status={row.status} data-id="element-1132" />
        }]} onRowClick={setSelectedItem} data-id="element-1131" />
        </div>
      </Card>
      <Drawer isOpen={!!selectedItem} onClose={() => setSelectedItem(null)} title="Forecast Details" size="md" footer={<>
            <Button variant="ghost" onClick={() => setSelectedItem(null)} data-id="element-1134">
              Cancel
            </Button>
            <Button variant="secondary" data-id="element-1135">Flag Constraint</Button>
            <Button variant="primary" data-id="element-1136">Confirm</Button>
          </>} data-id="element-1133">
        {selectedItem && <div className="space-y-6" data-id="element-1137">
            <div data-id="element-1138">
              <h3 className="text-lg font-semibold text-text-primary mb-1" data-id="element-1139">
                {selectedItem.desc}
              </h3>
              <p className="text-sm text-text-secondary" data-id="element-1140">
                Material Code: {selectedItem.code}
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-1141">
              <div className="p-4 bg-surface-secondary rounded-fluent border border-border-light" data-id="element-1142">
                <p className="text-sm text-text-secondary mb-1" data-id="element-1143">Apr 2026</p>
                <p className="text-xl font-semibold" data-id="element-1144">{selectedItem.apr}</p>
              </div>
              <div className="p-4 bg-surface-secondary rounded-fluent border border-border-light" data-id="element-1145">
                <p className="text-sm text-text-secondary mb-1" data-id="element-1146">May 2026</p>
                <p className="text-xl font-semibold" data-id="element-1147">{selectedItem.may}</p>
              </div>
              <div className="p-4 bg-surface-secondary rounded-fluent border border-border-light" data-id="element-1148">
                <p className="text-sm text-text-secondary mb-1" data-id="element-1149">Jun 2026</p>
                <p className="text-xl font-semibold" data-id="element-1150">{selectedItem.jun}</p>
              </div>
              <div className="p-4 bg-surface-secondary rounded-fluent border border-border-light" data-id="element-1151">
                <p className="text-sm text-text-secondary mb-1" data-id="element-1152">Status</p>
                <StatusPill status={selectedItem.status} data-id="element-1153" />
              </div>
            </div>
            <div data-id="element-1154">
              <h4 className="font-medium mb-3 flex items-center gap-2 text-text-primary" data-id="element-1155">
                <MessageSquareIcon className="w-4 h-4" data-id="element-1156" /> Comments
              </h4>
              <div className="bg-surface-secondary p-4 rounded-fluent text-sm text-text-secondary border border-border-light" data-id="element-1157">
                No comments yet. Add a comment to communicate with the planner.
              </div>
            </div>
          </div>}
      </Drawer>
    </div>;
};